import { Box, Button, List, ListItem } from "@mui/material";
import React from "react";
import styles from "../../../styles/components/video.module.scss";
import styles1 from "../../../styles/components/submissionInformation.module.scss";
import { emptyHandle, getUtcDateTime } from "../../../lib/functions/utils.lib";
import assest from "../../../json/assest";

const PurchaseInformation = ({ data }) => {
  console.warn("data", data);
  const submissionList = [
    {
      textheading: "Asset Purchase Agreement",
      textname: "Successfully Signed",
    },
    {
      textheading: "Terms of Service",
      textname: "Agreed",
    },
    {
      textheading: "Purchase Date",
      textname: getUtcDateTime(data?.created_at),
    },
    {
      textheading: "VSID",
      textname: data?.id,
      class: true,
    },
    {
      textheading: "User IP address",
      textname: emptyHandle(data?.video_meta.ip_address),
    },
    {
      textheading: "Country",
      textname: emptyHandle(data?.country),
    },
    // {
    //   textheading: "Acquired By",
    //   textname: emptyHandle(data?.user?.name),
    // },
    {
      textheading: "Pre-Approved Flat Fee:",
      textname: emptyHandle(data?.revenue_share),
    },
  ];
  return (
    <>
      {data && (
        <Box className="VideocommonBox">
          <Box
            className={`${styles.ownerDetails} ${styles1.purchaseInformation}`}
          >
            <Box className={`${styles.commonHeading} ${styles1.commonHeading}`}>
              <h4>Purchase Information</h4>
            </Box>

            <Box
              className={`${styles.ownerDetailsTxt} ${styles1.ownerDetailsTxt}`}
            >
              <List>
                {submissionList.map((item, index) => {
                  return (
                    <ListItem
                      key={index}
                      className={
                        item.class ? styles1.ownerDetailsTxtBoxMiddle : ""
                      }
                    >
                      {/* <ListItem key={index}> */}

                      <Box className={styles.ownerDetailsTxtBox}>
                        <h4>{item.textheading}</h4>
                        <h5>{item.textname}</h5>
                      </Box>
                    </ListItem>
                  );
                })}
                <ListItem className={styles1.ownerDetailsTxtBoxMiddle}>
                  <Box className={styles.purchaseAgreement}>
                    <Button>
                      <img
                        src={assest.purchaseAgreement}
                        width={14}
                        height={16}
                        alt=""
                      />{" "}
                      Purchase Agreement
                    </Button>
                  </Box>
                </ListItem>
              </List>
            </Box>
          </Box>
        </Box>
      )}
    </>
  );
};

export default PurchaseInformation;
